import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  navigationButton: {
    minWidth: 0,
    width: theme.spacing(5),
    height: theme.spacing(5),
    background: theme.palette.tab.offselected,
    '&:hover': { background: theme.palette.tab.offselected }
  },
  textStyle: {
    fontSize: theme.spacing(1.7),
    color: theme.palette.primary.light,
    fontWeight: 400
  },
  tableRow: {
    background: theme.palette.background.default,
    '& > *': {
      borderColor: theme.palette.input.border,
      borderWidth: 1,
      borderStyle: 'solid'
    }
  },
  containerItems: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginRight: 4,
  },
  itemInCell: {
    background: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.input.border,
    padding: theme.spacing(1),
    borderRadius: 2,
    '&:hover': { background: theme.palette.input.border }
  },
  iconPlus: { color: theme.palette.background.paper },
  row2: {
    width: 200,
    padding: theme.spacing(0, 1)

  },
  row4: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: theme.spacing(0.5),
  },
  mobileCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: theme.palette.background.default,
    borderColor: theme.palette.input.border,
  },
  mobileCardTitle: {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.primary.light,
    fontWeight: 400,
  },
  mobileCardSelectRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
  },
  mobileCardSelectField: {
    flex: 1,
    minWidth: 0,
  },
  underline: {
    fontSize: theme.spacing(2),
    color: theme.palette.primary.light,
    fontWeight: 500,
    paddingLeft: theme.spacing(1),
    '&&&:before': { borderBottom: 'none' },
    '&&:after': { borderBottom: 'none' },
    '&:hover': { background: theme.palette.input.border },
    '& .MuiFilledInput-input': { paddingTop: theme.spacing(2)!, }
  }
}));
